import React from 'react';

interface TryhardH2Props {
    children: any
}

const TryhardH2: React.FC<TryhardH2Props> = ({ children }) => {
    return (
        <div 
            className='text-teko text-4xl sm:text-5xl text-red-700 italic px-4 py-2 min-w-max'
            style={{ filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, .4))' }}
        >
            {children}
        </div>
    )
}

export default TryhardH2;